import React from "react";
import ProductTemplate from "../../ProductTemplate";
import sf85Cover from "../../../assets/sf85/SF85Hero.png";
import sf85a from "../../../assets/sf85/sf85a.webp";
import sf85b from "../../../assets/sf85/sf85b.webp";
import sf85c from "../../../assets/sf85/sf85c.webp";
import sf85d from "../../../assets/sf85/sf85d.webp";
import sf85e from "../../../assets/sf85/sf85e.webp";
import sf85f from "../../../assets/sf85/sf85f.webp";
import sf85sec1 from "../../../assets/sf85/sf85sec1.webp";
import sf85sec2 from "../../../assets/sf85/sf85sec2.webp";
import sf85sec3 from "../../../assets/sf85/sf85sec3.webp";
import sf85sec4 from "../../../assets/sf85/sf85sec4.webp";
import sf85sec5 from "../../../assets/sf85/sf85sec5.webp";
import sf85sec6 from "../../../assets/sf85/sf85sec6.webp";

const Sf85 = () => {
  const data = {
    title: "ALUMIL SF85",
    subtitle: "SUPREME SF85 Insulated Folding Doors",
    description:
      "A world-class highly insulated folding door system with bottom-slide operation, combining minimal aesthetics with outstanding performance, very large dimensions with literally low sight lines, enhanced burglar protection with a very large variety of solutions.",
    specifications: [
      { label: "MAXIMUM HEIGHT", value: "4.0 m" },
      { label: "MAXIMUM WIDTH", value: "1.5 m" },
      { label: "THERMAL INSULATION", value: "Yes" },
      { label: "GLAZING THICKNESS", value: "21-58 mm" },
      { label: "MAXIMUM WEIGHT", value: "200 kg/vent" },
      { label: "WATER TIGHTNESS", value: "7A/9A (with subsill)" },
      { label: "AIR PERMEABILITY", value: "Class 4" },
      { label: "WIND LOAD RESISTANCE", value: "Class C3/B3" },
      { label: "BURGLAR RESISTANCE", value: "RC2 IFT & PAS24 (UK)" },
    ],
    renders: [sf85Cover, sf85a, sf85b, sf85c, sf85d, sf85e, sf85f],
    typologies: [], // No typologies provided in the original file
    sections: [sf85sec1, sf85sec2, sf85sec3, sf85sec4, sf85sec5, sf85sec6],
    relatedFiles: [
      {
        label: "SUPREME Systems",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/general/supreme-brochure-gr-en.pdf?sfvrsn=5bdefc43_90",
      },
      {
        label: "SF85 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/supreme/supreme-sf85.pdf?sfvrsn=a54b85df_21",
      },
      {
        label: "SF85 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/supreme/sf85_en.pdf?sfvrsn=4705adb6_35",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default Sf85;